import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import theme from './theme';
import { loadConfig } from './config'; // Import the config loader
import './styles/global.css'; // Import global styles

const root = ReactDOM.createRoot(document.getElementById('root'));

// Load Config Before Rendering the App
const initializeApp = async () => {
  try {
    console.log('Configuration loaded successfully');
    root.render(
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    );
  } catch (error) {
    console.error('Failed to load configuration:', error);
    root.render(<h1>Failed to load configuration. Please try again later.</h1>);
  }
};

// Start the app initialization
initializeApp();